import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSuccessToast } from '../store/successToastStore';
export function SuccessToast() {
  const {
    message,
    hideToast
  } = useSuccessToast();
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        hideToast();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, hideToast]);
  return <AnimatePresence data-id="element-319" data-mp="q2yrhxui5ffs">
      {message && <motion.div initial={{
      y: -60,
      x: '-50%',
      opacity: 0
    }} animate={{
      y: 0,
      x: '-50%',
      opacity: 1
    }} exit={{
      y: -60,
      x: '-50%',
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed top-[16px] left-1/2 z-[9999] bg-success/95 backdrop-blur-sm rounded-pill px-5 py-2.5 shadow-elevated flex items-center gap-2 whitespace-nowrap" data-id="element-320" data-mp="l2kj2eozo3h8">
          <CheckCircle size={16} className="text-white flex-shrink-0" data-id="element-321" data-mp="pcoa5zy4n3p6" />
          <span className="text-white text-[14px] font-medium" data-id="element-322" data-mp="pav3iknikjh6">{message}</span>
        </motion.div>}
    </AnimatePresence>;
}